var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegrationsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none",
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.357.071H.286A.215.215 0 0 0 .07.286v4.071c0 .118.097.214.215.214h4.071a.215.215 0 0 0 .214-.214V.286A.215.215 0 0 0 4.357.07m-.696 3.59H.982V.982h2.679zM9.714.07H5.643a.215.215 0 0 0-.214.215v4.071c0 .118.096.214.214.214h4.071a.215.215 0 0 0 .215-.214V.286A.215.215 0 0 0 9.714.07m-.696 3.59H6.339V.982h2.679zm-4.66 1.768H.285a.215.215 0 0 0-.215.214v4.071c0 .118.097.215.215.215h4.071a.215.215 0 0 0 .214-.215v-4.07a.215.215 0 0 0-.214-.214M3.66 9.018H.982V6.339h2.679zm6.053-3.59h-4.07a.215.215 0 0 0-.214.215v4.071c0 .118.096.215.214.215h4.071a.215.215 0 0 0 .215-.215V5.643a.215.215 0 0 0-.215-.214m-.696 3.59H6.339v-2.68h2.679z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationsIcon);
export default __webpack_public_path__ + "static/media/integrations-icon.2cf82ae914949bdff1b61c5831ab8e84.svg";
export { ForwardRef as ReactComponent };